<template>
  <div id="app">
    <rb-sidebar v-if="!hideLayout" :role="this.role" />
    <rb-topbar v-if="!hideLayout" />
    <div :class="[hideLayout ? 'mar' : 'main-content', 'mt-4']">
      <router-view></router-view>
    </div>
    <rb-footer v-if="!hideLayout" />
  </div>
</template>

<script>
export default {
  name: "App",
  computed: {
    hideLayout() {
      return this.$route.path == "/login" || this.$route.path == "/redirect";
    },
  },
};
</script>
